export default function access(
  initialState: { currentUser?: API.UserData; permissions?: API.UserPermissionData[] } | undefined
) {
  const { currentUser, permissions: permissionsData } = initialState ?? {};

  const permissions = permissionsData?.map((item: API.UserPermissionData) => item.code);

  if (!permissions || !currentUser) {
    return {};
  }

  return {
    permissionsData: initialState,
    isSuperAdmin: currentUser && Boolean(currentUser.isSuperAdmin),
    canViewSystemConfigList: currentUser && currentUser.isSuperAdmin === 1,

    canViewSystemConfig: permissions.includes('SYS_SYSTEM_CONFIG_VIEW'),
    canEditSystemConfig: permissions.includes('SYS_SYSTEM_CONFIG_EDIT'),

    // 1. Danh sách nhân viên (Module ID: 1)
    canCreateEmployee: permissions.includes('HRM_EMPLOYEE_CREATE'),
    canViewEmployee: permissions.includes('HRM_EMPLOYEE_VIEW'),
    canEditEmployee: permissions.includes('HRM_EMPLOYEE_EDIT'),
    canDeleteEmployee: permissions.includes('HRM_EMPLOYEE_DELETE'),
    canExportEmployee: permissions.includes('HRM_EMPLOYEE_EXPORT'),
    canApproveEmployee: permissions.includes('HRM_EMPLOYEE_APPROVE'),

    // 2. Công ty/Bộ phận (Module ID: 2)
    canCreateCompany: permissions.includes('HRM_COMPANY_CREATE'),
    canViewCompany: permissions.includes('HRM_COMPANY_VIEW'),
    canEditCompany: permissions.includes('HRM_COMPANY_EDIT'),
    canDeleteCompany: permissions.includes('HRM_COMPANY_DELETE'),
    canExportCompany: permissions.includes('HRM_COMPANY_EXPORT'),

    canCreateDepartment: permissions.includes('HRM_DEPARTMENT_CREATE'),
    canViewDepartment: permissions.includes('HRM_DEPARTMENT_VIEW'),
    canEditDepartment: permissions.includes('HRM_DEPARTMENT_EDIT'),
    canDeleteDepartment: permissions.includes('HRM_DEPARTMENT_DELETE'),
    canExportDepartment: permissions.includes('HRM_DEPARTMENT_EXPORT'),

    // 3. Chức danh (Module ID: 3)
    canCreateTitle: permissions.includes('HRM_TITLE_CREATE'),
    canViewTitle: permissions.includes('HRM_TITLE_VIEW'),
    canEditTitle: permissions.includes('HRM_TITLE_EDIT'),
    canDeleteTitle: permissions.includes('HRM_TITLE_DELETE'),
    canExportTitle: permissions.includes('HRM_TITLE_EXPORT'),

    // Organization Level (Cấu hình cấp bậc tổ chức)
    canCreateOrganizationLevel: permissions.includes('HRM_UNIT_TYPE_CREATE'),
    canViewOrganizationLevel: permissions.includes('HRM_UNIT_TYPE_VIEW'),
    canEditOrganizationLevel: permissions.includes('HRM_UNIT_TYPE_EDIT'),
    canDeleteOrganizationLevel: permissions.includes('HRM_UNIT_TYPE_DELETE'),
    canExportOrganizationLevel: permissions.includes('HRM_UNIT_TYPE_EXPORT'),

    // 4. Cấu hình (Module ID: 4)
    canCreateConfig: permissions.includes('HRM_CONFIG_CREATE'),
    canViewConfig: permissions.includes('HRM_CONFIG_VIEW'),
    canEditConfig: permissions.includes('HRM_CONFIG_EDIT'),
    canDeleteConfig: permissions.includes('HRM_CONFIG_DELETE'),

    // 5. Danh sách hợp đồng (Module ID: 5)
    canCreateContract: permissions.includes('HRM_CONTRACT_CREATE'),
    canViewContract: permissions.includes('HRM_CONTRACT_VIEW'),
    canEditContract: permissions.includes('HRM_CONTRACT_EDIT'),
    canDeleteContract: permissions.includes('HRM_CONTRACT_DELETE'),

    // 6. Phụ lục hợp đồng (Module ID: 6)
    canCreateContractAppendix: permissions.includes('HRM_CONTRACT_APPENDIX_CREATE'),
    canViewContractAppendix: permissions.includes('HRM_CONTRACT_APPENDIX_VIEW'),
    canEditContractAppendix: permissions.includes('HRM_CONTRACT_APPENDIX_EDIT'),
    canDeleteContractAppendix: permissions.includes('HRM_CONTRACT_APPENDIX_DELETE'),

    // 7. Cấu hình (Module ID: 7)
    canCreateContractConfig: permissions.includes('HRM_CONTRACT_CONFIG_CREATE'),
    canViewContractConfig: permissions.includes('HRM_CONTRACT_CONFIG_VIEW'),
    canEditContractConfig: permissions.includes('HRM_CONTRACT_CONFIG_EDIT'),
    canDeleteContractConfig: permissions.includes('HRM_CONTRACT_CONFIG_DELETE'),

    // 8. Quản lý client chấm công (Module ID: 8)
    canCreateAttendanceClient: permissions.includes('HRM_ATTENDANCE_CLIENT_CREATE'),
    canViewAttendanceClient: permissions.includes('HRM_ATTENDANCE_CLIENT_VIEW'),
    canEditAttendanceClient: permissions.includes('HRM_ATTENDANCE_CLIENT_EDIT'),
    canDeleteAttendanceClient: permissions.includes('HRM_ATTENDANCE_CLIENT_DELETE'),
    canExportAttendanceClient: permissions.includes('HRM_ATTENDANCE_CLIENT_EXPORT'),

    // 9. Ca làm việc (Module ID: 9)
    canCreateWorkShift: permissions.includes('HRM_WORK_SHIFT_CREATE'),
    canViewWorkShift: permissions.includes('HRM_WORK_SHIFT_VIEW'),
    canEditWorkShift: permissions.includes('HRM_WORK_SHIFT_EDIT'),
    canDeleteWorkShift: permissions.includes('HRM_WORK_SHIFT_DELETE'),
    canExportWorkShift: permissions.includes('HRM_WORK_SHIFT_EXPORT'),

    // 10. Danh sách phân ca/lịch làm việc (Module ID: 10)
    canCreateShiftAssign: permissions.includes('HRM_SHIFT_ASSIGN_CREATE'),
    canViewShiftAssign: permissions.includes('HRM_SHIFT_ASSIGN_VIEW'),
    canEditShiftAssign: permissions.includes('HRM_SHIFT_ASSIGN_EDIT'),
    canDeleteShiftAssign: permissions.includes('HRM_SHIFT_ASSIGN_DELETE'),
    canExportShiftAssign: permissions.includes('HRM_SHIFT_ASSIGN_EXPORT'),

    // 11. Danh sách lịch làm việc chi tiết (Module ID: 11)
    canViewShiftDetail: permissions.includes('HRM_SHIFT_DETAIL_VIEW'),

    // 12. Quản lý lịch nghỉ lễ (Module ID: 12)
    canCreateHoliday: permissions.includes('HRM_HOLIDAY_CREATE'),
    canViewHoliday: permissions.includes('HRM_HOLIDAY_VIEW'),
    canEditHoliday: permissions.includes('HRM_HOLIDAY_EDIT'),
    canDeleteHoliday: permissions.includes('HRM_HOLIDAY_DELETE'),
    canExportHoliday: permissions.includes('HRM_HOLIDAY_EXPORT'),

    // 13. Đề xuất (Module ID: 13)
    canCreateProposal: permissions.includes('HRM_PROPOSAL_CREATE'),
    canViewProposal: permissions.includes('HRM_PROPOSAL_VIEW'),
    canEditProposal: permissions.includes('HRM_PROPOSAL_EDIT'),
    canDeleteProposal: permissions.includes('HRM_PROPOSAL_DELETE'),
    canExportProposal: permissions.includes('HRM_PROPOSAL_EXPORT'),
    canApproveProposal: permissions.includes('HRM_PROPOSAL_APPROVE'),

    // 14. Quản lý quỹ phép (Module ID: 14)
    canCreateLeaveFund: permissions.includes('HRM_LEAVE_FUND_CREATE'),
    canViewLeaveFund: permissions.includes('HRM_LEAVE_FUND_VIEW'),
    canEditLeaveFund: permissions.includes('HRM_LEAVE_FUND_EDIT'),
    canDeleteLeaveFund: permissions.includes('HRM_LEAVE_FUND_DELETE'),
    canImportLeaveFund: permissions.includes('HRM_LEAVE_FUND_IMPORT'),
    canExportLeaveFund: permissions.includes('HRM_LEAVE_FUND_EXPORT'),

    // 15. Làm thêm giờ (Module ID: 15)
    canCreateOvertime: permissions.includes('HRM_OVERTIME_CREATE'),
    canViewOvertime: permissions.includes('HRM_OVERTIME_VIEW'),
    canEditOvertime: permissions.includes('HRM_OVERTIME_EDIT'),
    canDeleteOvertime: permissions.includes('HRM_OVERTIME_DELETE'),
    canExportOvertime: permissions.includes('HRM_OVERTIME_EXPORT'),
    canApproveOvertime: permissions.includes('HRM_OVERTIME_APPROVE'),

    // 16. Dữ liệu chấm công thô (Module ID: 16)
    canViewAttendanceRaw: permissions.includes('HRM_ATTENDANCE_RAW_VIEW'),
    canExportAttendanceRaw: permissions.includes('HRM_ATTENDANCE_RAW_EXPORT'),

    // 17. Bảng công chi tiết (Module ID: 17)
    canViewTimesheetDetail: permissions.includes('HRM_TIMESHEET_DETAIL_VIEW'),
    canLockUnlockTimesheetDetail: permissions.includes('HRM_TIMESHEET_DETAIL_LOCK_UNLOCK'),
    canImportTimesheetDetail: permissions.includes('HRM_TIMESHEET_DETAIL_IMPORT'),
    canExportTimesheetDetail: permissions.includes('HRM_TIMESHEET_DETAIL_EXPORT'),
    canSendTimesheetMail: permissions.includes('HRM_TIMESHEET_MAIL_SEND'),

    // 17b. Cấu hình email bảng công
    canViewTimesheetMailConfig: permissions.includes('HRM_ATTENDANCE_CONFIG_VIEW'),
    canCreateTimesheetMailConfig: permissions.includes('HRM_ATTENDANCE_CONFIG_CREATE'),
    canEditTimesheetMailConfig: permissions.includes('HRM_ATTENDANCE_CONFIG_EDIT'),
    canDeleteTimesheetMailConfig: permissions.includes('HRM_ATTENDANCE_CONFIG_DELETE'),

    // 18. Bảng công tổng hợp (Module ID: 18)
    canViewTimesheetSummary: permissions.includes('HRM_TIMESHEET_SUMMARY_VIEW'),
    canExportTimesheetSummary: permissions.includes('HRM_TIMESHEET_SUMMARY_EXPORT'),

    // 19. Cấu hình (Module ID: 19)
    canCreateAttendanceConfig: permissions.includes('HRM_ATTENDANCE_CONFIG_CREATE'),
    canViewAttendanceConfig: permissions.includes('HRM_ATTENDANCE_CONFIG_VIEW'),
    canEditAttendanceConfig: permissions.includes('HRM_ATTENDANCE_CONFIG_EDIT'),
    canDeleteAttendanceConfig: permissions.includes('HRM_ATTENDANCE_CONFIG_DELETE'),

    // 20. Quản lý công việc (Module ID: 20)
    canCreateTask: permissions.includes('HRM_TASK_CREATE'),
    canViewTask: permissions.includes('HRM_TASK_VIEW'),
    canEditTask: permissions.includes('HRM_TASK_EDIT'),
    canDeleteTask: permissions.includes('HRM_TASK_DELETE'),
    canExportTask: permissions.includes('HRM_TASK_EXPORT'),

    // 21. Quản lý nhóm vai trò (Module ID: 21)
    canCreateRoleGroup: permissions.includes('SYS_ROLE_GROUP_CREATE'),
    canViewRoleGroup: permissions.includes('SYS_ROLE_GROUP_VIEW'),
    canEditRoleGroup: permissions.includes('SYS_ROLE_GROUP_EDIT'),
    canDeleteRoleGroup: permissions.includes('SYS_ROLE_GROUP_DELETE'),

    // 22. Quản lý người dùng (Module ID: 22)
    canCreateUser: permissions.includes('SYS_USER_CREATE'),
    canViewUser: permissions.includes('SYS_USER_VIEW'),
    canEditUser: permissions.includes('SYS_USER_EDIT'),
    canDeleteUser: permissions.includes('SYS_USER_DELETE'),
    canExportUser: permissions.includes('SYS_USER_EXPORT'),
    canLockUnlockUser: permissions.includes('SYS_USER_LOCK_UNLOCK'),

    // 23. Cấu hình thông báo (Module ID: 23)
    canCreateNotification: permissions.includes('SYS_NOTIFICATION_CREATE'),
    canViewNotification: permissions.includes('SYS_NOTIFICATION_VIEW'),
    canEditNotification: permissions.includes('SYS_NOTIFICATION_EDIT'),
    canDeleteNotification: permissions.includes('SYS_NOTIFICATION_DELETE'),
    canExportNotification: permissions.includes('SYS_NOTIFICATION_EXPORT'),

    // 24. Quản lý tham số chung (Module ID: 24)
    canCreateParameter: permissions.includes('SYS_PARAMETER_CREATE'),
    canViewParameter: permissions.includes('SYS_PARAMETER_VIEW'),
    canEditParameter: permissions.includes('SYS_PARAMETER_EDIT'),
    canDeleteParameter: permissions.includes('SYS_PARAMETER_DELETE'),
    canExportParameter: permissions.includes('SYS_PARAMETER_EXPORT'),

    // 25. Cấu hình dashboard (Module ID: 25)
    canCreateDashboard: permissions.includes('SYS_DASHBOARD_CREATE'),
    canViewDashboard: permissions.includes('SYS_DASHBOARD_VIEW'),
    canEditDashboard: permissions.includes('SYS_DASHBOARD_EDIT'),
    canDeleteDashboard: permissions.includes('SYS_DASHBOARD_DELETE'),

    // 26. Báo cáo hợp đồng (Module ID: 26)
    canViewContractReport: permissions.includes('HRM_CONTRACT_REPORT_VIEW'),
    canExportContractReport: permissions.includes('HRM_CONTRACT_REPORT_EXPORT'),
  };
}
